import type { SerializedManufacturer } from '@enmon/commons/lib/tools';
import { useServices } from 'containers/services';
import { useAppNotifications } from 'hooks';
import type { DeleteManufacturerArg } from 'lib/services';
import { useMutation, type UseMutationResult, useQueryClient } from 'react-query';
import { getErrorMessage } from 'utils/getErrorMessage';
import { MUTATION_KEYS, QUERY_KEYS } from 'utils/queryKeys';

export const useDeleteManufacturer = (): UseMutationResult<SerializedManufacturer, unknown, DeleteManufacturerArg> => {
  const queryClient = useQueryClient();
  const { manufacturersApiClient } = useServices();
  const notify = useAppNotifications();

  return useMutation({
    mutationKey: MUTATION_KEYS.manufacturers.deleteOne(),
    mutationFn: async (arg: DeleteManufacturerArg) => await manufacturersApiClient.delete(arg),
    onError: err => {
      console.error(err);
      notify.error({
        message: 'There was an error while deleting manufacturer',
        description: err instanceof Error ? getErrorMessage(err) : undefined,
      });
    },
    onSuccess: () => {
      queryClient.invalidateQueries(QUERY_KEYS.manufacturers.all());
      notify.success({
        message: `Manufacturer deleted`,
      });
    },
  });
};
